<template>
    <div id="image">
        <img src="../assets/construct_dex.png" height="350px">
    </div>
</template>

<script>
export default {
    name: 'logo'
}
</script>